import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, fillTemplate } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { useSeo } from "@/lib/seo";

export const RichText = ({ text }) => (
  <div className="space-y-5 text-[#3F3530] leading-relaxed">
    {text.split(/\n{2,}/).map((block, i) => {
      const lines = block.split("\n");
      return (
        <div key={i} className="space-y-2">
          {lines.map((l, j) => {
            if (l.startsWith("## ")) return <h2 key={j} className="font-serif-ym text-2xl font-semibold text-[#1A1513] pt-4">{l.slice(3)}</h2>;
            if (l.startsWith("- ")) return <p key={j} className="pl-5 relative before:content-[''] before:absolute before:left-0 before:top-2.5 before:h-1.5 before:w-1.5 before:rotate-45 before:bg-[#D4AF37]">{l.slice(2)}</p>;
            return <p key={j}>{l}</p>;
          })}
        </div>
      );
    })}
  </div>
);

export default function LegalPage() {
  const { slug } = useParams();
  const { settings } = useSite();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(false);
  useSeo({
    title: page ? `${page.title} | Yeni Mercan Restoran Buca` : "Yeni Mercan Restoran",
    description: page ? `${page.title} – Yeni Mercan Restoran Buca, İzmir yasal bilgilendirme metni.` : undefined,
    path: `/yasal/${slug}`,
  });

  useEffect(() => {
    setPage(null);
    setError(false);
    api.get(`/pages/${slug}`).then(({ data }) => {
      setPage(data);
    }).catch(() => setError(true));
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div className="bg-[#FAF7F2] min-h-screen" data-testid="legal-page">
      <Header />
      <div className="ym-dark pt-40 pb-16">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#CBBBAE] hover:text-[#D4AF37]" data-testid="legal-back-link"><ArrowLeft size={14} /> Ana sayfa</Link>
          <p className="eyebrow mt-8">Yasal Bilgilendirme</p>
          <h1 className="mt-3 font-serif-ym text-4xl sm:text-5xl font-semibold" data-testid="legal-title">{page?.title || (error ? "Sayfa bulunamadı" : "Yükleniyor…")}</h1>
        </div>
      </div>
      <main className="mx-auto max-w-4xl px-5 sm:px-8 py-16" data-testid="legal-content">
        {page && <RichText text={fillTemplate(page.content, settings)} />}
        {page?.updated_at && <p className="mt-12 text-xs text-[#6B5E56]">Son güncelleme: {new Date(page.updated_at).toLocaleDateString("tr-TR")}</p>}
      </main>
      <Footer />
    </div>
  );
}
